import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './json-editor.html';

const jsonEditorConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('jsoneditor', {
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.modes = [
				'tree',
				'view',
				'form',
				'code',
				'text',
			];

			// Toggle selection for a given mode by name
			$scope.toggleSelection = function toggleSelection(/** @type {any} */ mode, /** @type {string[]} */ modes) {
				const index = modes.indexOf(mode);

				// Is currently selected
				if (index > -1) {
					modes.splice(index, 1);
				}
				// Is newly selected
				else {
					modes.push(mode);
				}
			};
		},
		title:        'JSON Editor',
		template,
		children:   false,
		selectable: true,
		settings:     {
			hideLabel:    false,
			autofocus:    false,
			input:        false,
			tableView:    false,
			label:        'JSON Editor',
			key:          'jsoneditor',
			defaultValue: '',
			protected:    false,
			persistent:   true,
			hidden:       false,
			clearOnHide:  true,
			preferText:   true,
			options:      {
				colorPicker:     true,
				enableSort:      true,
				enableTransform: true,
				escapeUnicode:   false,
				history:         true,
				indentation:     2,
				mainMenuBar:     true,
				mode:            'tree',
				modes:           [],
				name:            undefined,
				navigationBar:   true,
				search:          true,
				statusBar:       true,
				templates:       [],
				timestampTag:    true,
			},
			kdata: {
				submit: true,
			},
			validate:     {
				schema: null,
			},
			event: {
				onChange: null,
			},
		},
		icon:         'fa fa-file-code-o',
		noDndOverlay: true,
		views:        [
			{
				name:     'Display',
				template: 'kform/components/jsoneditor/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/jsoneditor/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			if ($scope.options && $scope.options.building) {
				return;
			}

			const temporaryOptions = angular.copy($scope.component.options);

			$scope.$watch('component.options.name', (/** @type {any} */ newName, /** @type {any} */ oldName) => {
				if (newName !== oldName && angular.isString(newName) && newName.trim() === '') {
					$scope.component.options.name = undefined;
				}
			});
			$scope.$watch('readOnly', () => {
				if ($scope.readOnly === true) {
					$scope.component.options.mode = 'view';
					$scope.component.options.modes = [];
				}
				else {
					$scope.component.options.mode = temporaryOptions.mode;
					$scope.component.options.modes = temporaryOptions.modes;
				}
			});

			$scope.changeValue = () => {
				if (angular.isString($scope.component.event.onChange)) {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
	});
};

export default angular.module('app').config(jsonEditorConfig);
